import React from 'react';
import { useCurrentEditor, useEditorState } from '@tiptap/react';
import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';
import { FONT_CSS_MAP } from './data';

const ToolbarFontSelect = () => {
	const { editor } = useCurrentEditor();

	const editorState = useEditorState({
		editor,
		selector: (ctx) => {
			return {
				activeFont: ctx.editor?.getAttributes('textStyle').fontFamily,
			};
		},
	});

	const activeFontKey =
		Object.entries(FONT_CSS_MAP).find(([key, css]) => css === editorState.activeFont)?.[0] ??
		'arial';

	const fontFields = Object.entries(FONT_CSS_MAP).map(([key, css]) => ({
		label: key.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
		value: key,
		css,
		type: 'font',
		default: 'arial',
	}));

	return (
		<ToolbarDropdown
			title='Font'
			showSelection={true}
			defaultValue={activeFontKey}
			fields={fontFields}
			onChange={(e) => {
				const key = e.target.value;
				const css = fontFields.find((f) => f.value === key)?.css;
				console.log('Editor', { editor, key });
				editor.chain().focus().setFontFamily(css).run();
			}}
			sx={{
				width: '110px',
			}}
		/>
	);
};

export default ToolbarFontSelect;
